export default {"src":"/_next/static/media/openLink.7cc4c00d.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};